module.exports = __webpack_public_path__ + "img/icon_status.375e1be3.svg";